import React from 'react';

import Code from '../base';

const codestring = `package main

import (
    "crypto/tls"
    "fmt"

    resty "gopkg.in/resty.v1"
)

func main() {
    baseUrl := "https://b2b-api.lana.xyz"
    username := "131d905a-4adc-4415-aae8-999c3c3ed728"
    password := "cO_PKTP5KZ5GsMa4lgXrR41lUVgDWje5ZDPWphrRPOs"

    businessID := "b897ce0c92eb30bf17632677d4000b3e"

    client := resty.New().
        SetHostURL(baseUrl).
        SetHeader("Accept", "application/json").
        SetBasicAuth(username, password)

    res, err := client.R().Get(fmt.Sprintf("/business/%s/accounts", businessID))
    if err != nil {
        panic(err.Error())
    }

    fmt.Printf("%v\\n", res)
}`;

const GoFetchAccounts = () => <Code language="go" codestring={codestring} />;

export default GoFetchAccounts;
